"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/dispute-loss-reason.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fdispute-loss-reason.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.disputeLossReasonToJSON = exports.disputeLossReasonFromJSON = exports.DisputeLossReason = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.proto';
/**
 * Copied directly from Stripe:
 * https://stripe.com/docs/api/issuing/disputes/object#issuing_dispute_object-loss_reason
 * NOTE: You need to be logged into the production issuing account to access
 *   the above Beta documentation!
 */
var DisputeLossReason;
(function (DisputeLossReason) {
    DisputeLossReason["INVALID_DISPUTE_LOSS_REASON"] = "INVALID_DISPUTE_LOSS_REASON";
    /**
     * TRANSACTION_AUTHORIZED - The merchant has provided evidence that indicates this transaction was
     * authorized by the cardholder. Stripe has evaluated this evidence and
     * determined that it is compelling.
     */
    DisputeLossReason["TRANSACTION_AUTHORIZED"] = "TRANSACTION_AUTHORIZED";
    /**
     * TRANSACTION_ELECTRONICALLY_READ - The liability shifts to the issuer for fraudulent disputes if the
     * card-present transaction was authorized with a chip-reading terminal. This
     * dispute was automatically rejected by the card network.
     */
    DisputeLossReason["TRANSACTION_ELECTRONICALLY_READ"] = "TRANSACTION_ELECTRONICALLY_READ";
    /**
     * INVALID_NO_AUTHORIZATION - The dispute, created under Condition 11.3: No Authorization, is invalid due
     * to the transaction being authorized as indicated in the Visa Core Rules and
     * Visa Product and Service Rules. The dispute was automatically rejected by
     * Visa.
     */
    DisputeLossReason["INVALID_NO_AUTHORIZATION"] = "INVALID_NO_AUTHORIZATION";
    /**
     * TRANSACTION_3D_REQUIRED - This dispute is invalid because the merchant attempted 3DS for a
     * Card-Not-Present (CNP) transaction, but the card provider did not have 3DS
     * enabled for the card. The dispute was automatically rejected by the card
     * network.
     */
    DisputeLossReason["TRANSACTION_3D_REQUIRED"] = "TRANSACTION_3D_REQUIRED";
    /**
     * EXCESS_DISPUTES_IN_TIMEFRAME - This dispute is invalid as more than 35 total disputes have been submitted
     * with 120 calendar days of this dispute. The dispute was automatically
     * rejected by the card network.
     */
    DisputeLossReason["EXCESS_DISPUTES_IN_TIMEFRAME"] = "EXCESS_DISPUTES_IN_TIMEFRAME";
    /**
     * MERCHANDISE_DELIVERED_OR_SHIPPED - The merchant provided evidence indicating that the merchandise was
     * shipped/delivered. Stripe has evaluated this evidence and determined that
     * it is compelling.
     */
    DisputeLossReason["MERCHANDISE_DELIVERED_OR_SHIPPED"] = "MERCHANDISE_DELIVERED_OR_SHIPPED";
    /**
     * TRANSACTION_QUALIFIES_FOR_VISA_EASY_PAYMENT_SERVICE - This dispute is invalid since the transaction qualifies for Visa Easy
     * Payment Service (VEPS) Transaction, which allows businesses to accept Visa
     * without customers pausing to sign or enter a PIN. With VEPS, the liability
     * shifts onto the card provider. The dispute was automatically rejected by
     * Visa.
     */
    DisputeLossReason["TRANSACTION_QUALIFIES_FOR_VISA_EASY_PAYMENT_SERVICE"] = "TRANSACTION_QUALIFIES_FOR_VISA_EASY_PAYMENT_SERVICE";
    /**
     * REFUND_ISSUED - The dispute is invalid because there is already a refund for the
     * transaction in full. The dispute was automatically rejected due to the
     * refund.
     */
    DisputeLossReason["REFUND_ISSUED"] = "REFUND_ISSUED";
    /**
     * TRANSACTION_APPROVED_AFTER_PRIOR_FRAUD_DISPUTE - The cardholder/card provider didn’t deactivate the card after claiming
     * fraud on previous transactions. The dispute was automatically rejected by
     * the card network.
     */
    DisputeLossReason["TRANSACTION_APPROVED_AFTER_PRIOR_FRAUD_DISPUTE"] = "TRANSACTION_APPROVED_AFTER_PRIOR_FRAUD_DISPUTE";
    /**
     * NOT_CANCELLED - The cardholder claims they canceled their subscription/order, but the
     * merchant has no record of such cancellation, nor was one provided by the
     * cardholder. Stripe has evaluated this evidence and determined that it is
     * compelling.
     */
    DisputeLossReason["NOT_CANCELLED"] = "NOT_CANCELLED";
    /**
     * MERCHANDISE_OR_SERVICE_AS_DESCRIBED - The merchant provided information indicating the item/service provided
     * matched the description. Stripe has evaluated this evidence and determined
     * that it is compelling.
     */
    DisputeLossReason["MERCHANDISE_OR_SERVICE_AS_DESCRIBED"] = "MERCHANDISE_OR_SERVICE_AS_DESCRIBED";
    /**
     * OTHER_LOSS_REASON - The dispute was not able to match the loss reason internally. Please
     * contact Support or your Account Manager for more information.
     */
    DisputeLossReason["OTHER_LOSS_REASON"] = "OTHER_LOSS_REASON";
    /**
     * TRANSACTION_UNATTENDED - This dispute is invalid as the transaction was unattended, chip-initiated,
     * and online authorized (e.g., swiping a chip card at an unattended gas pump,
     * parking meter, or ATM). The liability is on the card provider for these
     * types of transactions. The dispute was automatically rejected by the card
     * network.
     */
    DisputeLossReason["TRANSACTION_UNATTENDED"] = "TRANSACTION_UNATTENDED";
    /**
     * INVALID_DUPLICATE_DISPUTE - This dispute, created under Condition 12.6: Duplicate Processing/Paid by
     * Other Means, has not met the criteria set by Visa. The dispute was
     * automatically rejected by Visa.
     */
    DisputeLossReason["INVALID_DUPLICATE_DISPUTE"] = "INVALID_DUPLICATE_DISPUTE";
    /**
     * UNRECOGNIZED_DISPUTE_LOSS_REASON - We couldn't identify the Dispute loss reason provided by Stripe.
     */
    DisputeLossReason["UNRECOGNIZED_DISPUTE_LOSS_REASON"] = "UNRECOGNIZED_DISPUTE_LOSS_REASON";
    DisputeLossReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DisputeLossReason || (exports.DisputeLossReason = DisputeLossReason = {}));
function disputeLossReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DISPUTE_LOSS_REASON':
            return DisputeLossReason.INVALID_DISPUTE_LOSS_REASON;
        case 1:
        case 'TRANSACTION_AUTHORIZED':
            return DisputeLossReason.TRANSACTION_AUTHORIZED;
        case 2:
        case 'TRANSACTION_ELECTRONICALLY_READ':
            return DisputeLossReason.TRANSACTION_ELECTRONICALLY_READ;
        case 3:
        case 'INVALID_NO_AUTHORIZATION':
            return DisputeLossReason.INVALID_NO_AUTHORIZATION;
        case 4:
        case 'TRANSACTION_3D_REQUIRED':
            return DisputeLossReason.TRANSACTION_3D_REQUIRED;
        case 5:
        case 'EXCESS_DISPUTES_IN_TIMEFRAME':
            return DisputeLossReason.EXCESS_DISPUTES_IN_TIMEFRAME;
        case 6:
        case 'MERCHANDISE_DELIVERED_OR_SHIPPED':
            return DisputeLossReason.MERCHANDISE_DELIVERED_OR_SHIPPED;
        case 7:
        case 'TRANSACTION_QUALIFIES_FOR_VISA_EASY_PAYMENT_SERVICE':
            return DisputeLossReason.TRANSACTION_QUALIFIES_FOR_VISA_EASY_PAYMENT_SERVICE;
        case 8:
        case 'REFUND_ISSUED':
            return DisputeLossReason.REFUND_ISSUED;
        case 9:
        case 'TRANSACTION_APPROVED_AFTER_PRIOR_FRAUD_DISPUTE':
            return DisputeLossReason.TRANSACTION_APPROVED_AFTER_PRIOR_FRAUD_DISPUTE;
        case 11:
        case 'NOT_CANCELLED':
            return DisputeLossReason.NOT_CANCELLED;
        case 12:
        case 'MERCHANDISE_OR_SERVICE_AS_DESCRIBED':
            return DisputeLossReason.MERCHANDISE_OR_SERVICE_AS_DESCRIBED;
        case 13:
        case 'OTHER_LOSS_REASON':
            return DisputeLossReason.OTHER_LOSS_REASON;
        case 14:
        case 'TRANSACTION_UNATTENDED':
            return DisputeLossReason.TRANSACTION_UNATTENDED;
        case 15:
        case 'INVALID_DUPLICATE_DISPUTE':
            return DisputeLossReason.INVALID_DUPLICATE_DISPUTE;
        case 16:
        case 'UNRECOGNIZED_DISPUTE_LOSS_REASON':
            return DisputeLossReason.UNRECOGNIZED_DISPUTE_LOSS_REASON;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DisputeLossReason.UNRECOGNIZED;
    }
}
exports.disputeLossReasonFromJSON = disputeLossReasonFromJSON;
function disputeLossReasonToJSON(object) {
    switch (object) {
        case DisputeLossReason.INVALID_DISPUTE_LOSS_REASON:
            return 'INVALID_DISPUTE_LOSS_REASON';
        case DisputeLossReason.TRANSACTION_AUTHORIZED:
            return 'TRANSACTION_AUTHORIZED';
        case DisputeLossReason.TRANSACTION_ELECTRONICALLY_READ:
            return 'TRANSACTION_ELECTRONICALLY_READ';
        case DisputeLossReason.INVALID_NO_AUTHORIZATION:
            return 'INVALID_NO_AUTHORIZATION';
        case DisputeLossReason.TRANSACTION_3D_REQUIRED:
            return 'TRANSACTION_3D_REQUIRED';
        case DisputeLossReason.EXCESS_DISPUTES_IN_TIMEFRAME:
            return 'EXCESS_DISPUTES_IN_TIMEFRAME';
        case DisputeLossReason.MERCHANDISE_DELIVERED_OR_SHIPPED:
            return 'MERCHANDISE_DELIVERED_OR_SHIPPED';
        case DisputeLossReason.TRANSACTION_QUALIFIES_FOR_VISA_EASY_PAYMENT_SERVICE:
            return 'TRANSACTION_QUALIFIES_FOR_VISA_EASY_PAYMENT_SERVICE';
        case DisputeLossReason.REFUND_ISSUED:
            return 'REFUND_ISSUED';
        case DisputeLossReason.TRANSACTION_APPROVED_AFTER_PRIOR_FRAUD_DISPUTE:
            return 'TRANSACTION_APPROVED_AFTER_PRIOR_FRAUD_DISPUTE';
        case DisputeLossReason.NOT_CANCELLED:
            return 'NOT_CANCELLED';
        case DisputeLossReason.MERCHANDISE_OR_SERVICE_AS_DESCRIBED:
            return 'MERCHANDISE_OR_SERVICE_AS_DESCRIBED';
        case DisputeLossReason.OTHER_LOSS_REASON:
            return 'OTHER_LOSS_REASON';
        case DisputeLossReason.TRANSACTION_UNATTENDED:
            return 'TRANSACTION_UNATTENDED';
        case DisputeLossReason.INVALID_DUPLICATE_DISPUTE:
            return 'INVALID_DUPLICATE_DISPUTE';
        case DisputeLossReason.UNRECOGNIZED_DISPUTE_LOSS_REASON:
            return 'UNRECOGNIZED_DISPUTE_LOSS_REASON';
        case DisputeLossReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.disputeLossReasonToJSON = disputeLossReasonToJSON;
//# sourceMappingURL=dispute-loss-reason.js.map